import { cn } from "@holigral/shared/ui/lib/utils"
import { useT } from "@/i18n"

type Props = {
  variant?: "full" | "glyph" | "wordmark"
  size?: string | number
  className?: string
}

/**
 * Profiling.app's own name, set as text.
 *
 * This is deliberately *not* the Holigral lockup. Profiling.app is its own
 * front door with the same tokens, and what belongs top left here has not been
 * decided — so the product name stays as it was until it is. The foundation's
 * "never set the logotype in live text" is about the Holigral logotype, which
 * is a drawing; this is a product name, which is a word.
 *
 * The drawn mark lives in `@holigral/shared/ui/brand` when it is wanted.
 */
export default function Logo({ variant = "full", size, className }: Props) {
  const { t } = useT()
  const style = size
    ? { fontSize: typeof size === "number" ? `${size}px` : size }
    : undefined

  return (
    <span
      className={cn("inline-flex items-center gap-[0.08em]", className)}
      style={style}
    >
      {variant !== "glyph" && (
        <span className="font-sans text-[1em] leading-none font-medium tracking-tight">
          {t("appName")}
        </span>
      )}
    </span>
  )
}
